// import styled from 'styled-components'

// import PageTopTitle from "../../components/shared/PageTopTitle"
// import { useDispatch, useSelector } from "react-redux"
// import { useEffect} from "react"

// import Button from '../../components/shared/button/Btn'
// import { showModal } from '../../features/modal/modalSlice'
// import DevamliAraclarContainer from '../../components/devamlıAraclarContainers/DevamliAraclarContainer'
// import { devamliAraclarFiltre, getGunlukAracList, setAddVehicleFromDevamliAraclar, setCleanDevamliAracFilter } from '../../features/joblist/jobListSlice'
// import PlakaSearchInput from '../../components/shared/devamliAraclar/PlakaSearchInput'
// import AracTipiInput from '../../components/shared/devamliAraclar/AracTipiInput'
// import KasaTipiInput from '../../components/shared/devamliAraclar/KasaTipiInput'
// import DevamliAracSelectInput from '../../components/shared/devamliAraclar/isDevamliAracInput'
// import IsMemberKamyoonInput from '../../components/shared/devamliAraclar/isMemberKamyoonInput'
// import {getAracTypes} from "../../features/adminSett/adminSettSlice"
// import { BsCheck2 } from "react-icons/bs";
// import { AdminAracEkleOptions } from '../../utils/adminAracEkleOptions'
// import useWindowDimensions from '../../hooks/useWindowSize'
// import Btn from '../../components/shared/button/Btn'

// const Container = styled.div`

// width: 100%;

//     .wrapper{
//         display: flex;
//         flex-direction: column;
//         width: 100%;

//         .content{
//             width: calc(100% - 60px);
//             gap: 60px;
//             margin: 30px;
//             color: ${({ theme }) => theme.mainTextColor};
//             .top-container{
//               width: 100%;
//               display: flex;
//               justify-content: space-between;
//               margin: 20px 0;
//               flex-direction: column;
//               gap: 10px;
//               .inputs{
//                 display: flex ;
//                 align-items: center;
//                 gap: 10px;
//                 .input-container{
//                   display: flex;
//                   gap: 20px;
//                   width: 100%;
//                 }
//                 .clean{
//                   font-size: var(--font-size-sm);
//                   font-weight: var(--font-weight-md);
//                   color: var(--color-main);
//                   border: 1px solid var(--color-main);
//                   padding: 10px;
//                   border-radius: 10px;
//                   cursor: pointer;
//                   width: fit-content;
//                 }
//               }
              
//               .btn-container{
//                 display: flex;
//                 gap: 20px;
//               }
//             }
//         }

//         .pagination-container{
//             gap: 60px;
//             margin: 0 30px;
//             margin-top: 20px;
//             height: 200px;
//         }
//     }

//     @media (max-width: 1150px){
//         .inputs{
//           display: grid !important;
//           grid-template-columns: repeat(3, 1fr);
//         }
//     }
//     @media (max-width: 600px){
//         .inputs{
//           display: grid !important;
//           grid-template-columns: repeat(2, 1fr);
//         }
//     }
// `

// const DevamliAraclarim = () => {

//   const devamliAracSelectData = [
//     {
//       id:1,
//       value:"Tüm Araçlar",
//       bool:""
//     },
//     {
//       id:2,
//       value:"Devamlı Araçlarım",
//       bool:true
//     },
//     {
//       id:3,
//       value:"Devamlı Olmayan Araçlarım",
//       bool:false
//     }
//   ]

//   const isMemberKamyoonData = [
//     {
//       id:1,
//       value:"Tüm Üyeler",
//       bool: ""
//     },
//     {
//       id:2,
//       value:"Kamyoon Üyesi Olanlar",
//       bool:true
//     },
//     {
//       id:3,
//       value:"Kamyoon Üyesi Olmayanlar",
//       bool:false
//     }
//   ]

//   const { devamliAraclarFilterValues, devamliAracList }  = useSelector((state)=> state.jobList)
//   const {plakaSearch, phoneNumberSearch, aracTuruValue, kasaTipiValue, isDevamliArac, isMemberOfKamyoon, kasaTypeOptions} = devamliAraclarFilterValues
//   const {aracTypes} = useSelector((state)=> state.adminSett)
//   const {windowDimensions} = useWindowDimensions()

//   const dispatch = useDispatch()

//   useEffect(()=>{
//     dispatch(getAracTypes())
//   },[dispatch])

//   useEffect(()=>{
//     dispatch(devamliAraclarFiltre({plakaSearch:plakaSearch, phoneNumberSearch: phoneNumberSearch, aracTuruValue:aracTuruValue.name, kasaTipiValue:kasaTipiValue.name, isDevamliArac:isDevamliArac.bool, isMemberOfKamyoon:isMemberOfKamyoon.bool}))
//   },[plakaSearch, phoneNumberSearch, aracTuruValue, kasaTipiValue, isDevamliArac, isMemberOfKamyoon])

//   return (
//     <Container>
//     <div className="wrapper">
//         <PageTopTitle title={"Sürücüler ve Araçlar"} position="sticky"/>
//         <div className="content">
//           <div className="top-container">
//             <div className="inputs">
//               <div className="input-container">
//                 <PlakaSearchInput data={plakaSearch} name="plakaOrPhoneSearch" labelText='Plaka' keyData="plakaSearch" inputWidth={"100%"}/>
//               </div>
//               <div className="input-container">
//                 <PlakaSearchInput data={phoneNumberSearch} name="plakaOrPhoneSearch" labelText='Cep Telefonu' keyData="phoneNumberSearch" inputWidth={"100%"}/>
//               </div>
//               <div className="input-container">
//                 <AracTipiInput  data={aracTuruValue} options={AdminAracEkleOptions} name="aracTuruValue" labelText='Araç Türü' keyData="aracTuruValue" inputWidth={"100%"}/>
//               </div>
//               <div className="input-container">
//                 <KasaTipiInput  data={kasaTipiValue} options={kasaTypeOptions} name="kasaTipiValue" labelText='Kasa Tipi' keyData="kasaTipiValue" inputWidth={"100%"}/>
//               </div>
//               <div className="input-container">
//                 <DevamliAracSelectInput data={isDevamliArac} name="isDevamliArac" options={devamliAracSelectData} labelText='Tüm Araçlarım' keyData="isDevamliArac" inputWidth={"100%"}/>
//               </div>
//               <div className="input-container">
//                 <IsMemberKamyoonInput  data={isMemberOfKamyoon} name="isMemberOfKamyoon" options={isMemberKamyoonData} labelText='Üyelik' keyData="isMemberOfKamyoon" inputWidth={"100%"}/>
//               </div>
//               <div onClick={()=> dispatch(setCleanDevamliAracFilter())} className='clean'>Temizle</div>
//             </div>
//             <div className="btn-container">
//               {/* <Button type='button' background={"#fff"} width={"fit-content"} color={"#E85446"} handleClick={()=> {dispatch(showModal("addDriverAndVehicle")); dispatch(setAddVehicleFromDevamliAraclar(true))}} padding='0 20px'>Sürücü ve Araç Ekle</Button> */}
//               <Btn handleClick={() => dispatch(showModal("addRegularDriverPhoneNumberQuery"))} color={"#E85446"} bgColor='transprent' width={"200px"}>Sürücü Araç Ekle</Btn>
//             </div>
//           </div>
//           {devamliAracList?.map((item)=>(
//             <DevamliAraclarContainer data={item} />
//           ))}
//         </div>
        
//         <div className="pagination-container">
            
//         </div>
//     </div>
// </Container>
//   )
// }

// export default DevamliAraclarim


import styled from 'styled-components'

import PageTopTitle from "../../components/shared/PageTopTitle"
import { useDispatch, useSelector } from "react-redux"
import { useEffect} from "react"

import Button from '../../components/shared/button/Btn'
import { showModal } from '../../features/modal/modalSlice'
import DevamliAraclarContainer from '../../components/devamlıAraclarContainers/DevamliAraclarContainer'
import { devamliAraclarFiltre, getGunlukAracList, setAddVehicleFromDevamliAraclar, setCleanDevamliAracFilter } from '../../features/joblist/jobListSlice'
import PlakaSearchInput from '../../components/shared/devamliAraclar/PlakaSearchInput'
import AracTipiInput from '../../components/shared/devamliAraclar/AracTipiInput'
import KasaTipiInput from '../../components/shared/devamliAraclar/KasaTipiInput'
import DevamliAracSelectInput from '../../components/shared/devamliAraclar/isDevamliAracInput'
import IsMemberKamyoonInput from '../../components/shared/devamliAraclar/isMemberKamyoonInput'
import {getAracTypes} from "../../features/adminSett/adminSettSlice"
import { BsCheck2 } from "react-icons/bs";
import { AdminAracEkleOptions } from '../../utils/adminAracEkleOptions'
import useWindowDimensions from '../../hooks/useWindowSize'
import Btn from '../../components/shared/button/Btn'
import { getAllRegularDrivers } from '../../features/driversVehicles/driversVehiclesSlice'
import SingleRegularDriverItem from '../../components/driversVehicles/SingleRegularDriverItem'

const Container = styled.div`

width: 100%;

    .wrapper{
        display: flex;
        flex-direction: column;
        width: 100%;

        .content{
            width: calc(100% - 60px);
            gap: 60px;
            margin: 30px;
            color: ${({ theme }) => theme.mainTextColor};
            .top-container{
              width: 100%;
              display: flex;
              justify-content: space-between;
              margin: 20px 0;
              flex-direction: column;
              gap: 10px;

            }

            .list{
              display: flex;
              flex-direction: column;
              gap: 20px;
            }
        }

        .pagination-container{
            gap: 60px;
            margin: 0 30px;
            margin-top: 20px;
            height: 200px;
        }
    }

    @media (max-width: 1150px){
        .inputs{
          display: grid !important;
          grid-template-columns: repeat(3, 1fr);
        }
    }
    @media (max-width: 600px){
        .inputs{
          display: grid !important;
          grid-template-columns: repeat(2, 1fr);
        }
    }
`

const RegularDriversVehicles = () => {

  const dispatch = useDispatch()
  const {isLoadingGetAllRegularDrivers, allRegularDriversList} = useSelector(state => state.driversVehicles)

  // useEffect(()=>{
  //   dispatch(getAracTypes())
  // },[dispatch])


  useEffect(() => {
    dispatch(getAllRegularDrivers())
  },[])

  



  return (
    <Container>
    <div className="wrapper">
        <PageTopTitle title={"Sürücüler ve Araçlar"} position="sticky"/>
        <div className="content">
          <div className="top-container">
            <Btn width={"240px"} bgColor="transparent" color="#E85446" handleClick={() => dispatch(showModal("addRegularDriverPhoneNumberQuery"))}>Sürücü Ekle</Btn>
          </div>
          {
            <div className="list">
              {
                allRegularDriversList?.map(item => (
                  <SingleRegularDriverItem item={item}/>
                ))
              }
            </div>
          }
        </div>
        
        <div className="pagination-container">
            
        </div>
    </div>
</Container>
  )
}

export default RegularDriversVehicles